<template>
  <div>
    <el-form :inline="true" :model="query" class="query-form" size="small">
      <el-form-item>
        <el-date-picker
          v-model="servetime"
          type="datetimerange"
          :picker-options="pickerOptions"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="left"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          @change="dateChange"
        ></el-date-picker>
      </el-form-item>
      <el-form-item class="query-form-item" label="处理状态">
        <el-select
          v-model="query.serveorderstatus"
          placeholder="全部"
          @change="onSubmit"
          clearable
        >
          <el-option label="已处理" value="1"></el-option>
          <el-option label="待处理" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="query-form-item">
        <el-input
          placeholder="订单号、联系人、联系电话"
          v-model="query.servetest"
          prefix-icon="el-icon-search"
          @keyup.enter.native="onSubmit"
          clearable
        >
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-refresh"
          @click="onRest"
        ></el-button>
        <el-button type="primary" icon="el-icon-search" @click="onSubmit"
          >查询</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-download"
          size="small"
          @click="exportExcel()"
          >导出</el-button
        >
      </el-form-item>
    </el-form>
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="list"
      :header-cell-style="{ background: '#F4F4F5', color: '#606266' }"
      @selection-change="handleSelectionChange"
      border
    >
      <el-table-column
        label="订单号"
        align="center"
        width="200"
        prop="serveorderno"
      />
      <el-table-column
        label="服务名称"
        align="left"
        
        prop="servetitle"
      />
      <el-table-column
        label="联系人"
        align="center"
        width="100"
        prop="serveordername"
      />
      <el-table-column
        label="联系电话"
        align="center"
      
        prop="serveorderphone"
      />
      <el-table-column
        label="详情描述"
        align="center"

        prop="serveorderdetail"
      />
      <el-table-column
        label="提交时间"
        align="center"
      >
        <template slot-scope="scope">
          <i class="el-icon-time"></i>
          <span>{{
            scope.row.serveordertime | formatDateStr("yyyy-MM-dd hh:mm:ss")
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="处理状态"  width="100" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.serveorderstatus == 0">待处理</span>
          <span v-if="scope.row.serveorderstatus == 1">已处理</span>
        </template>
      </el-table-column>
      <el-table-column width="300" label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click.native="handleInfo(scope.$index, scope.row)"
            >查看</el-button
          >
          <el-button
            v-if="scope.row.serveorderstatus == 0"
            type="primary"
            size="mini"
            @click.native="handle(scope.row)"
            >处理</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination-container"
      background
      :current-page="query.currentPage"
      :page-size="query.pageSize"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total,sizes,prev, pager, next, jumper"
      :page-sizes="[10, 20, 30, 50]"
      :total="totalNumber"
    ></el-pagination>

    <!--  查看 --->
    <el-dialog
      title="服务订单管理/详情"
      :visible.sync="formInfo"
      :before-close="hideInfo"
      width="800px"
      top="5vh"
      v-dialogDrag
    >
      <el-form :model="formData">
        <el-form-item
          style="border-bottom:1px solid #ebeef5;"
          label-width="0px"
        >
          <el-form-item
            label="用户昵称:"
            prop="servetitle"
            style="width:50%;display: inline-block;margin-left:0px;"
          >
            <input v-model="formData.usernick" type="text" readonly />
          </el-form-item>
          <el-form-item
            label="邮箱地址:"
            prop="servetitle"
            style="width:50%;display: inline-block"
          >
            <input v-model="formData.useremail" type="text" readonly />
          </el-form-item>
        </el-form-item>
        <el-form-item
          style="border-bottom:1px solid #ebeef5;"
          label-width="0px"
        >
          <el-form-item
            label="提交时间:"
            prop="servetitle"
            style="width:50%;display: inline-block;margin-left:0px;"
          >
            <span>{{
              formData.serveordertime | formatDateStr("yyyy-MM-dd hh:mm:ss")
            }}</span>
          </el-form-item>
          <el-form-item
            label="联系人:"
            prop="servetitle"
            style="width:30%;display: inline-block"
          >
            <input v-model="formData.serveordername" type="text" readonly />
          </el-form-item>
        </el-form-item>
        <el-form-item
          style="border-bottom:1px solid #ebeef5;"
          label-width="0px"
        >
          <el-form-item
            label="联系电话:"
            prop="servetitle"
            style="width:50%;display: inline-block;margin-left:0px;"
          >
            <input v-model="formData.serveorderphone" type="text" readonly />
            <el-button
              v-if="formData.serveorderstatus == 0"
              type="primary"
              size="mini"
              @click.native="handle(formData)"
              >处理</el-button
            >
          </el-form-item>
        </el-form-item>
        <el-form-item label="详情描述:" prop="servetitle">
          <div v-html="formData.serveorderdetail" />
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getList, handle } from "../../api/order/serveOrder.js";
import { formatDateStr } from "../../filtres/index";
import { BASE_URL } from "../../config/app";
const formJson = {
  serveorderid: "",
  serveid: "",
  usernick: "",
  useremail: "",
  serveordertime: "",
  serveordername: "",
  serveorderphone: "",
  serveorderstatus: "",
  serveorderdetail: ""
};
export default {
  data() {
    return {
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近六个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      cancelToggle: false,
      servetime: [],
      pushtime: "",
      query: {
        serveorderid: "",
        serveid: "",
        serveorderstatus: "",
        servetest: "",
        startTime: "",
        endTime: "",
        currentPage: 1,
        pageSize: 10
      },
      list: [],
      totalNumber: 0,
      loading: true,
      index: null,
      formName: null,
      formLoading: false,
      formInfo: false,
      formData: formJson,
      formRules: {},
      multipleSelection: [] //多选集合
    };
  },
  methods: {
    dateChange(val) {
      if (val == null) {
        this.query.startTime = "";
        this.query.endTime = "";
      } else {
        this.query.startTime = val[0];
        this.query.endTime = val[1];
      }
      this.getList();
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      if (val == "") {
        this.cancelToggle = false;
        return;
      }
      this.cancelToggle = true;
    },
    delGroup() {
      var ids = this.multipleSelection.map(item => item.serveid).join(); //获取所有选中行的id组成的字符串，以逗号分隔

      if (ids == "") {
        this.$message({
          message: "请先选择",
          type: "warning"
        });
        return;
      }
      this.handleDel(ids);
    },
    onRest() {
      this.query = {
        currentPage: 1,
        pageSize: 10
      };
      this.servetime = [];
      this.getList();
    },
    hideInfo() {
      // 更改值
      this.formInfo = !this.formInfo;
      // 清空表单
      return true;
    },
    onSubmit() {
      this.$router.push({
        path: "",
        query: this.query
      });
      this.getList();
    },
    handleCurrentChange(val) {
      this.query.currentPage = val;
      //scrollTo(0, 800);
      this.getList();
    },
    handleSizeChange(val) {
      this.query.pageSize = val;
      this.getList();
    },
    getList() {
      this.loading = true;
      getList(this.query)
        .then(response => {
          if (response.code) {
            this.$message.error(response.message);
          }
          this.list = response.data.list || [];
          this.totalNumber = response.data.totalNumber || 0;
          setTimeout(() => {
            this.loading = false;
          }, 0.3 * 1000);
        })
        .catch(() => {
          this.loading = false;
          this.list = [];
          this.totalNumber = 0;
        });
    },
    handleInfo(index, row) {
      this.formInfo = true;
      this.formData = Object.assign({}, formJson);
      if (row !== null) {
        this.formData = Object.assign({}, row);
      }
      // 清空验证信息表单
      if (this.$refs["dataForm"]) {
        this.$refs["dataForm"].clearValidate();
      }
    },
    // 处理
    handle(row) {
      this.$confirm("确定该服务订单已处理吗?", "提示", {
        type: "warning"
      })
        .then(() => {
          this.loading = true;
          this.query.serveorderid = row.serveorderid;
          this.query.serveid = row.serveid;
          handle(this.query)
            .then(response => {
              this.loading = false;
              if (response.code) {
                this.$message.error(response.message);
                return false;
              }
              this.$message.success("操作成功");
              // 刷新数据
              //this.list.splice(index, 1);
              this.formInfo = false;
              this.getList();
            })
            .catch(() => {
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    //导出
    exportExcel() {
      window.location.href = BASE_URL + "/serveOrderManage/export";
    }
  },
  mounted() {},
  created() {
    // 将参数拷贝进查询对象
    let query = this.$route.query;
    this.query = Object.assign(this.query, query);
    this.query.pageSize = parseInt(this.query.pageSize);
    // 加载表格数据
    this.getList();
  }
};
</script>

<style type="text/scss" lang="scss">
body {
  margin: 0;
}
</style>
